import core from "@/core";
import qs from "qs";

class ControlService {
  nareData = {
    control: {
      mode: {
        index: 1,
        name: "제어",
      },
    },
    relay: {
      floatingFan: {
        index: 0,
        name: "유동팬",
      },
      exhaustFan: {
        index: 1,
        name: "배기팬",
      },
      heater: {
        index: 2,
        name: "난방기",
      },
      fog: {
        index: 3,
        name: "포그기",
      },
      cameraUp: {
        index: 4,
        name: "카메라 상승",
      },
      cameraDown: {
        index: 5,
        name: "카메라 하강",
      },
    },
    state: {
      singleRoofWindowLeft: {
        index: 0,
        name: "1중 천창(좌)",
      },
      singleRoofWindowRight: {
        index: 1,
        name: "1중 천창(우)",
      },
      singleSideWindowLeft: {
        index: 2,
        name: "1중 측창(좌)",
      },
      singleSideWindowRight: {
        index: 3,
        name: "1중 측창(우)",
      },
      doubleRoofWindow: {
        index: 4,
        name: "2중 천창",
      },
      doubleSideWindow: {
        index: 5,
        name: "2중 측창",
      },
      shadingNet: {
        index: 6,
        name: "차광막",
      },
      roofThermalScreen: {
        index: 7,
        name: "보온커튼(상)",
      },
      frontRearThermalScreen: {
        index: 8,
        name: "보온커튼(전후)",
      },
    },
  };

  //devCtrl(devHost('rdayd'),'1','mode','5')
  controlNareMode(type) {
    return new Promise((resolve, reject) => {
      if (type !== "dashboard" && type !== "site") {
        reject("not support control value!");
        return;
      }
      let value = 0;
      if (type === "dashboard") {
        value = 5;
      } else if (type === "site") {
        value = 4;
      }

      const params = {
        host: "rdayd.asuscomm.com",
        dev_num: "1",
        ctrl: "mode",
        data1: value,
        data2: "0",
      };
      const strParam = qs.stringify(params);
      core.http
        .post("/nare", strParam)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  controlNareRelay(item, on) {
    return new Promise((resolve, reject) => {
      const value = on ? 1 : 0;

      const params = {
        host: "rdayd.asuscomm.com",
        dev_num: "1",
        ctrl: "dev",
        data1: item.index + 1,
        data2: value,
      };
      const strParam = qs.stringify(params);
      core.http
        .post("/nare", strParam)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  // devCtrl(host, '1', 'op',dev_num, ac);
  controlNareState(item, status) {
    return new Promise((resolve, reject) => {
      if (status !== "open" && status !== "close" && status !== "stop") {
        reject("not support control value!");
        return;
      }
      let value = 0;
      if (status === "open") {
        value = 1;
      } else if (status === "close") {
        value = 2;
      } else if (status === "stop") {
        value = 0;
      }

      const params = {
        host: "rdayd.asuscomm.com",
        dev_num: "1",
        ctrl: "op",
        data1: item.index + 1,
        data2: value,
      };
      const strParam = qs.stringify(params);
      core.http
        .post("/nare", strParam)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  // devCtrl(host, '1', 'per',dev_num, percent);
  controlNareOpenRate(item, value) {
    return new Promise((resolve, reject) => {
      // const value = on ? 1 : 0;

      const params = {
        host: "rdayd.asuscomm.com",
        dev_num: "1",
        ctrl: "per",
        data1: item.index + 1,
        data2: value,
      };
      const strParam = qs.stringify(params);
      core.http
        .post("/nare", strParam)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  getNareData() {
    return new Promise((resolve, reject) => {
      const params = {
        host: "naresys.iptime.org",
        dev_num: "1",
        ctrl: "get",
        data1: "0",
        data2: "0",
      };
      const strParam = qs.stringify(params);
      core.http
        .post("/nare", strParam, { ignoreAlertModal: true })
        .then((data) => {
          const response = {
            control: {},
            relay: {},
            relayList: [],
            state: {},
            stateList: [],
          };
          {
            const resultItems = data.rdayd;
            for (let key of Object.keys(this.nareData.control)) {
              const standard = this.nareData.control[key];
              const item = {
                key: key,
                type: "control",
                index: standard.index,
                code: resultItems[standard.index],
              };

              if (key === "mode") {
                if (item.code === 5) {
                  item.value = "dashboard";
                  item.name = "대시보드";
                } else {
                  item.value = "site";
                  item.name = "현장";
                }
              } else {
                console.log("Unknown key : ", key);
              }
              response.control[key] = item;
            }
          }

          {
            const resultItems = data.relay_state;
            for (let key of Object.keys(this.nareData.relay)) {
              const standard = this.nareData.relay[key];
              const item = {
                key: key,
                type: "relay",
                index: standard.index,
                code: resultItems[standard.index],
                name: standard.name,
              };
              item.on = item.code !== 0;
              response.relay[key] = item;
              response.relayList.push(item);
            }
          }

          {
            const percent = data.do_percent;
            const state = data.do_state;
            for (let key of Object.keys(this.nareData.state)) {
              const standard = this.nareData.state[key];
              const item = {
                key: key,
                type: "state",
                index: standard.index,
                code: state[standard.index],
                name: standard.name,
                value: percent[standard.index],
              };
              if (item.code === 0) {
                item.status = "stop";
              } else if (item.code === 1) {
                item.status = "open";
              } else if (item.code === 2) {
                item.status = "close";
              }
              response.state[key] = item;
              response.stateList.push(item);
            }
          }

          //console.log("response : ", response);
          console.log(response.control.mode.value);
          resolve(response);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }
}

export default new ControlService();
